import * as React from 'react'

import Stack from '../../Stack'
import * as Styled from '../Form.styles'
import Typography from '../../Typography'

const StepButtons = ({ name, instructions, label, options, nextStep }) => (
  <Styled.OptionGroup gridArea={name}>
    <Typography variant="h4">{instructions}</Typography>
    <Styled.Label>{label}</Styled.Label>
    <Stack spacing="sm">
      {options.map(
        ({ displayName, label: optionLabel, name: optionName, value }) => (
          <Styled.StepButton
            key={optionName}
            variant="default"
            rightIcon={<Styled.ChevronRight size="1.5em" />}
            gridArea={optionName}
            onClick={(e) => nextStep(e, name, value)}
          >
            <Styled.ButtonText>{displayName || optionLabel}</Styled.ButtonText>
          </Styled.StepButton>
        )
      )}
    </Stack>
  </Styled.OptionGroup>
)

export default StepButtons
